import { render, staticRenderFns } from "./ClientsEdit.vue?vue&type=template&id=7dda60f6&"
import script from "./ClientsEdit.vue?vue&type=script&lang=js&"
export * from "./ClientsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports